import type { ValidProperties } from '@wmgone/analytics';

import type { UserWithActions } from '~/modules/auth';

/**
 * Returns the properties that will be set on the User and that will also be
 * tracked with every Event.
 * @param user The user object.
 */
export function getDefaultSharedProperties(user: UserWithActions) {
  const { email, name, isInternal, profile, userId } = user;

  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  //
  //    ▄▄▄▖  ▗▖  ▗▖  ▗▄▄▖   ▗▄▖  ▗▄▄▖  ▗▄▄▄▖  ▗▄▖  ▗▖  ▗▖  ▗▄▄▄▖   ▐▌
  //     █    ▐▛▚▞▜▌  ▐▌ ▐▌ ▐▌ ▐▌ ▐▌ ▐▌   █   ▐▌ ▐▌ ▐▛▚▖▐▌    █     ▐▌
  //     █    ▐▌  ▐▌  ▐▛▀▘  ▐▌ ▐▌ ▐▛▀▚▖   █   ▐▛▀▜▌ ▐▌ ▝▜▌    █     ▐▌
  //    ▄█▄▖  ▐▌  ▐▌  ▐▌    ▝▚▄▞▘ ▐▌ ▐▌   █   ▐▌ ▐▌ ▐▌  ▐▌    █     ▗▖
  //
  //    These properties are used to identify the User and also added to the
  //    properties that are tracked for ALL events in ALL applicaitons
  //    (e.g. - WMG1, ADA, etc.).
  //
  //    DO NOT REMOVE ANYTHING FROM HERE WITHOUT FIRST CHECKING WITH THE TEAM!
  //
  //    At a bare mininm ask in the relevant channel (#ada-wmg1-amplitude-collab)
  //    so that everyone is aware of the potential change.
  //
  //    These values are more than likely being used for analytics and any
  //    changes can have huge effects on the data being collected/reported.
  //
  //    If anything needs to be removed for WMG1, make sure that it's added
  //    to the eventProperties (e.g. - see setEventProperties()) so that it
  //    continues to be tracked for each event in the other apps (e.g. - ADA).
  //
  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  const properties: ValidProperties = {
    name,
    email,
    is_external: !isInternal,
  };

  if (userId) {
    properties.user_id = userId;
  }

  if (profile) {
    properties.business_unit = profile.businessUnit;
    properties.job_family_group = profile.jobFamilyGroup;
    properties.team = profile.team;
    properties.label = profile.label;
    properties.job_title = profile.title;
    properties.country_code = profile.countryCode;
    properties.organization = profile.organization;
    properties.company = profile.company;
    properties.user_type = profile.userType;

    if (profile.description) {
      properties.user_description = profile.description;
    }

    if (profile.department) {
      properties.department = profile.department;
    }
  }

  return properties;
}
